import { withUniqueProgramKeys } from 'app/shared/modules/PricingWorkbench/ProgramResultsPanel/ProgramResultsPanel.programKey.utils';
import { createSelector } from 'reselect';

import { getProgramsCategory } from './programsCategory.selectors';

const selectPricingWorkbench = createSelector(
  getProgramsCategory,
  ({ pricingWorkbench }) => pricingWorkbench,
);

const selectPricing = createSelector(selectPricingWorkbench, ({ pricing }) => pricing);

export const selectFormattedPricing = createSelector(selectPricing, pricing => ({
  programsList: withUniqueProgramKeys(pricing?.programsReport?.programs),
  ratioData: pricing?.loanReport,
  adjustmentSnapshotId: pricing?.snapshotReport?.adjustmentsId,
  eligibilitySnapshotId: pricing?.snapshotReport?.eligibilityId,
  llpaCapSnapshotId: pricing?.snapshotReport?.llpaCapsId,
  ...pricing,
}));

export const selectCounties = createSelector(selectPricingWorkbench, ({ counties }) => counties);
